import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import Swiper, {SwiperOptions} from 'swiper';
import {SwiperModule} from 'swiper_angular';
import {ProductCardComponent} from '../product-card/product-card.component';
import {NgForOf, NgIf} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SubService} from 'src/app/services/sub.service';


@Component({
  selector: 'app-product-swiper',
  templateUrl: './product-swiper.component.html',
  styleUrls: ['./product-swiper.component.scss'],
  standalone: true,
  imports: [
    SwiperModule,
    ProductCardComponent,
    NgForOf,
    NgIf,
    IonicModule,
  ],
})
export class ProductSwiperComponent implements OnInit, AfterViewInit {
  showSwiper = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showSwiper = true;

    }, 500);
  }

  @Input() dataArray: any = [];
  config: SwiperOptions = {
    slidesPerView: 4.8,
    slidesPerGroup: 3,
    threshold: 0,
    spaceBetween: 15,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: false,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4.2,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4.8,
        spaceBetween: 15,
      },
    },
  };
  configMobile: SwiperOptions = {
    slidesPerView: 4.8,
    threshold: 0,
    spaceBetween: 15,
    freeMode: true,
    navigation: false,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4.2,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4.8,
        spaceBetween: 15,
      },
    },
  };
  isMobile: any;

  constructor(private cdr: ChangeDetectorRef, private sub: SubService) {
    this.sub.isMobile.subscribe((data) => {
      this.isMobile = data;
    });
  }

  canGetReachedEnd = false;
  reloadSwiper=true
  ngOnInit() {
    setTimeout(() => {
      this.canGetReachedEnd = true;
    }, 5000);



  }

  prev() {
    this.swiper.slidePrev();
  }

  next() {
    this.swiper.slideNext();
  }

  swiper: Swiper;

  swiperInit($event: [swiper: Swiper]) {
    this.swiper = $event[0];
  }

  activeIndex = 0;
  showNext = true;


  showPrev = false;

  activeIndexChange($event: [swiper: Swiper]) {
    this.activeIndex = $event[0].activeIndex;
    this.showNext = !$event[0].isEnd;
    this.showPrev = !$event[0].isBeginning;
    this.cdr.detectChanges();
  }


  reachEnd() {
    if (this.canGetReachedEnd) {
      this.showNext = false;
      this.cdr.detectChanges();
    }

  }
}
